var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "checkbox",
      class: { "has-error": _vm.localErrors.length, disabled: _vm.disabled }
    },
    [
      _c("input", {
        attrs: {
          id: _vm.id,
          type: "checkbox",
          required: _vm.required,
          disabled: _vm.disabled
        },
        domProps: { value: _vm.value, checked: _vm.checked },
        on: { change: _vm.updateValue }
      }),
      _vm._v(" "),
      _vm.label !== null
        ? _c("label", {
            staticClass: "font-smoothing",
            attrs: { for: _vm.id },
            domProps: { innerHTML: _vm._s(_vm.label) }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("x-errors-messages", { attrs: { errors: _vm.localErrors } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }